import { memo, useEffect, useState } from 'react';
import Link from 'next/link';
import cls from 'classnames';
import { FontCategory } from '@quicktools/shared-components/data/fonts';
import { Button, ButtonSizeSM, ButtonVariants } from '@picsart/ds-components/Button';
import { IconNewWindow } from '@picsart/ds-foundation/Icons/IconNewWindow';
import { ButtonSkinSecondary } from '@picsart/button/skins';

import { Category } from '../../types';
import analytics from '../../services/analytics';

import useStyles from './styles';
import { CategoryProps } from './types';

function getIdByCategory(id: FontCategory) {
  return `cat-${id}`;
}

function MobileCategories({ selected, categories }: CategoryProps) {
  const styles = useStyles();
  const [lastElementWidth, setLastElementWidth] = useState(120);

  const onItemClick = (category_name: string, page_name: string) => {
    analytics.sendGaEvent('category_select', {
      page_name,
      category_name,
    });
  };

  useEffect(() => {
    const isFirstElement = selected === categories[0];

    if (!isFirstElement) {
      const id = getIdByCategory(selected.id);
      const elem = document.getElementById(id);

      elem &&
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
    }
    setLastElementWidth(16);
  }, []);

  return (
    <div className={styles.root}>
      <Button
        endIcon={IconNewWindow}
        className={styles.button}
        skin={ButtonSkinSecondary}
        variant={ButtonVariants.Filled}
        size={ButtonSizeSM}
        onClick={() => window.open('https://picsart.com/fonts/', '_blank')}
      >
        Design with Fonts
      </Button>
      {categories.map((current: Category) => {
        const { text, href, Icon, pageName } = current;

        if (text === 'Letter cases') {
          return null;
        }

        return (
          <Link href={href} passHref={true} key={text}>
            <a
              key={text}
              id={getIdByCategory(current.id)}
              onClick={() => onItemClick(text, pageName)}
              className={cls(styles.entry, selected === current && styles.entrySelected)}
            >
              {Icon && <Icon className={styles.icon} />}
              <span className={styles.text}>{text}</span>
            </a>
          </Link>
        );
      })}
      {/*
         :last-child is weird in Safari:
         https://stackoverflow.com/questions/75214334/margin-right-on-last-child-isnt-working-in-safari
         Also in order to scroll to last element we use a hack which requires resetting the width.
       */}
      <div style={{ minWidth: lastElementWidth }}></div>
    </div>
  );
}

export default memo(MobileCategories);
